export const THEME = {
    token: {
        colorPrimary: '#0c64ae',
        colorLink: '#0c64ae',
        colorSuccess: "#52c41a",
        colorWarning: "#faad14",
        colorError: "#f5222d",
        colorTextBase :"rgb(55 55 55 / 75%)",
        colorBorder: '#d9d9d9',
        colorDisabled: 'rgba(0, 0, 0, 0.25)',
        colorSecondary: 'rgb(55 55 55 / 69%)',
        fontSize: 14,
        borderRadius: 5,
    },
}

export default THEME;